<template>
  <div class="main-section py-5 px-3">
    <div class="container-fluid text-white">
      <img src="/img/logopriadi.png" class="mx-auto d-block mb-4" style="width: 40%" alt="" />
      <p class="fw-bold h2 text-center mb-0">{{ $t('signup') }}</p>
      <p class="lead text-center fs-6">{{ $t('signupText') }}</p>

      <div class="form px-2 my-5">
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label class="form-label">{{ $t('fullname') }}</label>
            <input type="text" v-model="nama_lengkap" :placeholder="$t('fullnameHint')" class="form-control" />
            <small class="text-danger">{{ errors['nama_lengkap'] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">{{ $t('birthdate') }}</label>
            <input type="date" v-model="tgl_lahir" :placeholder="$t('birthdateHint')" class="form-control" />
            <small class="text-danger">{{ errors['tgl_lahir'] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">{{ $t('phone') }}</label>
            <input type="tel" v-model="nomor_handphone" :placeholder="$t('phoneHint')" class="form-control" />
            <small class="text-danger">{{ errors['nomor_handphone'] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">{{ $t('email') }}</label>
            <input type="email" v-model="alamat_email" :placeholder="$t('emailHint')" class="form-control" />
            <small class="text-danger">{{ errors['alamat_email'] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">{{ $t('password') }}</label>
            <input type="password" v-model="kata_sandi" :placeholder="$t('passwordHint')" class="form-control" />
            <small class="text-danger">{{ errors['kata_sandi'] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label">{{ $t('rePassword') }}</label>
            <input
              type="password"
              v-model="kata_sandi_confirm"
              :placeholder="$t('rePasswordHint')"
              class="form-control" />
            <small class="text-danger">{{ errors['kata_sandi_confirm'] }}</small>
          </div>

          <div class="form-check mb-5" style="font-size: 11pt">
            <input
              class="form-check-input"
              type="checkbox"
              id="flexCheckDefault"
              v-model="agreed"
              required
              @change="toggleAgree" />
            <label class="form-check-label" for="flexCheckDefault">
              {{ $t('agreeTerms') }}
              <router-link to="/nda" class="text-decoration-underline fw-bold">
                {{ $t('termsCondition') }}
              </router-link>
            </label>
          </div>

          <button class="btn btn-primary w-100 mb-3" :class="isAgree ? '' : 'disabled'">
            {{ $t('signup') }}
          </button>
        </form>

        <p class="text-center">
          {{ $t('hasAccount') }}
          <router-link to="/auth" class="fw-bold text-decoration-none">{{ $t('signin') }} </router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'Register',
  data() {
    return {
      errors: {},
      nama_lengkap: '',
      alamat_email: '',
      kata_sandi: '',
      kata_sandi_confirm: '',
      tgl_lahir: '',
      nomor_handphone: '',
      isAgree: false,
    }
  },
  methods: {
    toggleAgree() {
      this.isAgree = !this.isAgree
    },
    async submitForm() {
      this.errors['nama_lengkap'] =
        this.nama_lengkap.length < 2 ? this.$t('validation.minLength', { field: this.$t('fullname'), min: 2 }) : ''

      this.errors['alamat_email'] =
        this.alamat_email.length < 3 ? this.$t('validation.minLength', { field: this.$t('email'), min: 3 }) : ''

      this.errors['kata_sandi'] =
        this.kata_sandi.length < 8 ? this.$t('validation.minLength', { field: this.$t('password'), min: 8 }) : ''

      this.errors['kata_sandi_confirm'] =
        this.kata_sandi_confirm !== this.kata_sandi ? this.$t('validation.passwordMismatch') : ''

      this.errors['tgl_lahir'] = !this.tgl_lahir ? this.$t('validation.required', { field: this.$t('birthdate') }) : ''
      this.errors['nomor_handphone'] = !this.nomor_handphone
        ? this.$t('validation.required', { field: this.$t('phone') })
        : ''

      if (
        !this.errors['nama_lengkap'] &&
        !this.errors['alamat_email'] &&
        !this.errors['kata_sandi'] &&
        !this.errors['kata_sandi_confirm'] &&
        !this.errors['tgl_lahir'] &&
        !this.errors['nomor_handphone']
      ) {

        try {
          const formData = {
            fullname: this.nama_lengkap,
            email: this.alamat_email,
            password: this.kata_sandi,
            birthdate: this.tgl_lahir,
            phone_number: this.nomor_handphone,
          }

          const response = await axios.post('/api/register', formData)
          if (response.data.message) {
            Swal.fire({
              title: this.$t('success'),
              icon: 'success',
              text: this.$t('redirectLogin'),
              timer: 2000,
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading()
              },
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.timer) {
                this.$router.push('/auth')
              }
            })
          }
        } catch (error) {
          console.error('Registration error:', error)
          Swal.fire('Error', error.response?.data?.detail || 'Registration failed', 'error')
        }
      }
    },
  },
}
</script>

<style scoped>
.main-section {
  background-image: linear-gradient(to top, rgba(0, 119, 138, 0.3), rgba(0, 187, 216, 0.8)), url('/img/login.png');
  background-size: contain;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}
</style>
